
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'Footer' })
export default class extends Vue {
  get content(): string {
    return this.$portalString.footer_text_links ?? '<p>&copy; Ticketure</p>'
  }
}
